/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { AddWhite, DownloadIcon, SearchIcon } from '../../../../assets/icons';
import { Constants, fromStorage, getUpdatedState } from '../../../../utils';
import { Input, Modal, Pagination, Render } from '../../../../components';
import { ReportService } from '../../../../services';
import ModalCreateIncident from './modal-create-incident';

const Incidents = () => {
  const [showModal, setShowModal] = useState(false);
  const { data, downloadItem, filters, goToPage, onChange, pagination, reload, search } = useFetchTable();

  return (
    <main className="w-full">
      <div className="flex flex-wrap items-end gap-3">
        <Input
          className={{ base: 'max-w-64' }}
          placeholder="Buscar por conductor, CI"
          value={filters.search}
          onValueChange={v => onChange('search', v)}
          prepend={
            <img src={SearchIcon} className="w-4 h-4" alt="" />
          }
        />

        <Input
          className={{ base: 'max-w-44' }}
          placeholder="Cliente"
          value={filters.client}
          onValueChange={v => onChange('client', v)}
        />

        <Input
          className={{ base: 'max-w-44' }}
          placeholder="Ruta"
          value={filters.route}
          onValueChange={v => onChange('route', v)}
        />

        <Input
          className={{ base: 'max-w-44' }}
          type="date"
          label="Desde"
          value={filters.since}
          onValueChange={v => onChange('since', v)}
        />

        <Input
          className={{ base: 'max-w-44' }}
          type="date"
          label="Hasta"
          value={filters.until}
          onValueChange={v => onChange('until', v)}
        />

        <div className="flex gap-4">
          <button
            className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
            onClick={search}
          >
            Filtrar
          </button>
          <button
            className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
            onClick={() => reload()}
          >
            Limpiar
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">
            <span>Historial de Incidencias</span> 
            <Render condition={!filters.since && !filters.until}>
              <span className="capitalize text-base ml-4 px-3 py-1 rounded-full bg-orange/15 border border-red text-red">
                { moment().format('MMMM') }
              </span>
            </Render>
          </p>

          <button
            className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => setShowModal(true)}
          >
            <img src={AddWhite} className="w-4 h-4 brightness-200" alt="" />
            Nueva Incidencia
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-sm text-default font-semibold align-bottom">
                <th className="pl-4">Fecha y hora</th>
                <th>Cliente</th>
                <th>Ruta</th>
                <th>Conductor</th>
                <th>Incidencia</th>
                <th>Resultado</th>
                <th>Afectó al servicio</th>
                <th>Supervisor</th>
                <th>Observación</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item) => (
                <tr key={item.id} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <td>
                    <p>{ moment(item?.created_at).format('DD/MM/YYYY') }</p>
                    <p className="font-semibold">{ moment(item?.created_at).format('h:mm a') }</p>
                  </td>
                  <td>
                    <span className="text-orange font-semibold text-base">{ item?.user?.person?.fullName }</span>
                  </td>
                  <td>{ item?.route?.name }</td>
                  <td>{ item?.driver?.person?.name }</td>
                  <td>{ item?.incident_type?.name }</td>
                  <td>{ item?.result }</td>
                  <td>{ item?.is_affected ? 'Si' : 'No' }</td>
                  <td>{ item?.author?.person?.name }</td>
                  <td>{ item?.observations || '--' }</td>
                  <td>
                    <img
                      src={DownloadIcon}
                      className="w-5 h-5 object-contain cursor-pointer"
                      onClick={() => {
                        toast.promise(downloadItem(item.id), {
                          loading: 'Descargando...',
                          success: 'Reporte descargado con éxito',
                          error: 'Error al descargar el reporte',
                        });
                      }}
                      alt=""
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>

      <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
        {showModal && (
          <ModalCreateIncident onClose={() => setShowModal(false)} onSuccess={() => reload()} />
        )}
      </Modal>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    client: '',
    router: '',
    since: '',
    until: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [selects, setSelects] = useState({
    categories: [],
    subcategories: [],
    allSubcategories: [],
    status: [],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await ReportService.moderator.incidents.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const getSelects = async () => {
    const format = (items) => items?.map(x => ({ value: x.id, label: x.name })) || [];

    try {
      const response = await ReportService.moderator.incidents.getSelects();
      setSelects({
        categories: format(response.categories),
        allSubcategories: response.subcategories,
        subcategories: [],
        status: format(response.status),
      });

    } catch (error) {
      setSelects({
        categories: [],
        allSubcategories: [],
        subcategories: [],
        status: [],
      });
      toast.error(String(error));
    }
  }

  const downloadItem = async (id) => {
    try {
      const response = await ReportService.moderator.incidents.downloadOne(id);
      if (response.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      toast.error(String(error));
    }
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
    if (target === 'category') {
      setFilters(s => ({ ...s, subcategory: '' }));
      setSelects(s => ({
        ...s,
        subcategories: s.allSubcategories
          ?.filter(x => x.failure_category_id === +value)
          ?.map(x => ({ value: x.id, label: x.name })) || [],
      }));
    }
  }

  useEffect(() => {
    fetchData();
    getSelects();
  }, []);

  return {
    data,
    downloadItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    selects,
  }
}

export default Incidents;